import { Button } from "@msuite/ui/button";
import { Icon, icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Menu } from "@msuite/ui/menu";
import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import React from "react";
import { usePersonioSyncContext } from "./context";
import type { PersonioSyncRow } from "./utils";

export function PersonioSyncRowActions({ cell }: CellContext<PersonioSyncRow, "actions">) {
	/** Context */
	const { onRequestLink, onCreateAccount, onReset } = usePersonioSyncContext();

	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const row = cell.row.original;
	const isCreating = row.action === "create" || row.action === "adopt";

	/** Guard */
	if (row.state === "linked") return <React.Fragment />;

	/** Render */
	return (
		<RowActionsWrapper to={null}>
			<Menu
				items={() => [
					{
						label: t("integrations.personio_sync.link_member"),
						icon: icon("Link"),
						onClick: () => onRequestLink(row),
					},
					{
						label: t("integrations.personio_sync.create_account_instead"),
						icon: icon("UserPlus"),
						isDisabled: !row.canCreate || isCreating,
						onClick: () => onCreateAccount(row),
					},
					"divider",
					{
						label: t("integrations.personio_sync.reset_suggestion"),
						icon: icon("RotateCcw"),
						isDisabled: !row.isOverridden,
						onClick: () => onReset(row),
					},
				]}
			>
				<Button
					size="xxs"
					icon={<Icon name="EllipsisVertical" />}
					variant="ghost"
				/>
			</Menu>
		</RowActionsWrapper>
	);
}
